import { Stack, Typography } from '@mui/material';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

import { StationMarkerIcon } from '~assets/icons';
import { GoogleMapComponent } from '~components/molecules';
import { ICoordinate } from '~types';

type Props = {
  latitude?: number;
  longitude?: number;
  onMarkerDragEnd: (e: google.maps.MapMouseEvent) => void;
  onChangeCurrentLocation: (coordinates: ICoordinate) => void;
};

export const PinCoordinatesStep: React.FC<Props> = ({
  latitude,
  longitude,
  onMarkerDragEnd,
  onChangeCurrentLocation,
}) => {
  return (
    <Stack gap={2}>
      <Typography variant="h6" fontWeight={600}>
        Pin station's coordinates
      </Typography>
      <Typography variant="body1" fontWeight={500}>
        {`${latitude?.toFixed(5)}, ${longitude?.toFixed(5)}`}
      </Typography>
      <GoogleMapComponent
        defaultCenter={{
          lat: latitude ?? 0,
          lng: longitude ?? 0,
        }}
        onChangeCurrentLocation={onChangeCurrentLocation}
      >
        <AdvancedMarker
          draggable
          onDragEnd={onMarkerDragEnd}
          key={'Placement'}
          position={{
            lat: latitude ?? 0,
            lng: longitude ?? 0,
          }}
        >
          <StationMarkerIcon />
        </AdvancedMarker>
      </GoogleMapComponent>
    </Stack>
  );
};
